<!-- eslint-disable no-tabs -->
<template>
  <v-container fluid>
    <base-material-card
      color="primary"
      icon="mdi-database-plus"
      inline
      class="px-5 py-4 ml-0"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Pre Importações de Dados
        </div>
      </template>
      <v-btn
        id="btn-nova-importacao-dados-administracao"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float:left"
        relative
        text
        medium
        @click="$router.push('administracao/add')"
      >
        <v-icon left size="30px">
          mdi-plus-circle
        </v-icon>
        NOVA IMPORTAÇÃO
      </v-btn>
      <v-text-field
        id="importacao-dados-administracao-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto mt-4 break-search"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px;"
      />
      <v-divider class="mt-10" />
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :search.sync="search"
        :mobile-breakpoint="800"
        no-data-text="Nenhuma pré importação de Dados disponível"
      >
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate-column" v-bind="attrs" v-on="on">
                {{ item.arquivo_analista_setra.arquivo }}
              </div>
            </template>
            <span>{{ item.arquivo_analista_setra.arquivo }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.mapeamento`]="{ item }">
          <a href="javascript:void(0)" @click="selectedPreImpo = item; dialogMapeamento = true">{{ item.mapeamento.nome }}</a>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" :progresso="progresso[item.id]" />
        </template>
        <template v-slot:[`item.data`]="{ item }">
          {{item.created | parseToDateTimeBR}}
        </template>
	        <template v-slot:[`item.actions`]="{ item }">
	          <v-btn
	            v-if="item.status == 'FINALIZADO' && !item.importacao_dados"
            color="success"
            min-width="0"
            class="px-1 ml-n1"
            fab
            icon
            x-small
            @click="getTabelasAfetadas(item); checkConflitos(item)"
          >
            <v-icon
              small
            >
              mdi-database-plus
            </v-icon>
          </v-btn>
          <v-tooltip v-if="exibeDownloadLogsPreImportacao(item)" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                min-width="0"
                class="px-1"
                fab
                icon
                x-small
                v-bind="attrs"
                :loading="loadingLogsPreImportacao === item.id"
                :disabled="loadingLogsPreImportacao === item.id"
                v-on="on"
                @click="downloadLogsPreImportacao(item)"
              >
                <v-icon
                  small
                >
                  mdi-download
                </v-icon>
              </v-btn>
            </template>
            <span>Baixar logs da pré-importação</span>
          </v-tooltip>
          <v-tooltip v-if="exibeExcluirPreImportacao(item)" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-excluir-pre-importacao-dados-administracao"
                color="error"
                min-width="0"
                class="px-1"
                fab
                icon
                x-small
                v-bind="attrs"
                v-on="on"
                @click="openDialogDelete(item)"
              >
                <v-icon small>
                  mdi-trash-can-outline
                </v-icon>
              </v-btn>
            </template>
            <span>Excluir pré-importação</span>
          </v-tooltip>
          <v-btn
            id="action-log-importacao-dados-administracao"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            @click="dialogCreationLog = true, dialogCreationLogData = {username: item.usuario.nome, created: item.created}"
          >
	            <v-icon small> mdi-table-search</v-icon>
	          </v-btn>
	        </template>
	        <template v-slot:[`footer.page-text`]>
	          <v-tooltip bottom>
	            <template v-slot:activator="{ on, attrs }">
	              <v-icon color="primary" v-bind="attrs" v-on="on" @click="$emit('recharge')">mdi-refresh</v-icon>
	            </template>
	            <span>Clique aqui para recarregar as pré-importações</span>
	          </v-tooltip>
	        </template>
	      </v-data-table>
    </base-material-card>
    <dialog-mapeamento
      :dialog.sync="dialogMapeamento"
      :preImpo="selectedPreImpo"
    />
    <dialog-creation-log
      :dialog.sync="dialogCreationLog"
      :item="dialogCreationLogData"
    />
    <dialog-delete
      :showDialog="dialogDelete"
      :loading="loadingDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="excluirPreImportacao(dialogDeleteData.id)"
    >
      <template slot="title">
        Excluir Pré-importação #{{ dialogDeleteData.id }}
      </template>
      <template slot="body">
        Tem certeza que deseja excluir a pré-importação do arquivo
        <strong>{{ dialogDeleteData.nome }}</strong>?
      </template>
    </dialog-delete>
    <v-dialog
      v-model="dialogNovaImportacao"
      max-width="500px"
    >
      <v-card>
        <div v-if="conflitos">
          <v-row>
            <v-col cols="12">
              <v-card-title class="headline">
                Ações
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <div class="caption font-weight-light ml-2 mt-n2">
                      DEFINA AS AÇÕES A SEREM TOMADAS PELO SISTEMA PARA ESTAS OBRAS CONFLITANTES
                    </div>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col cols="12">
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <td>COD OBRA</td>
                            <td>AÇÃO</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(obra, key) in conflitosList">
                            <td>
                              <h3 class="d-inline-flex">{{ obra.CodObra }}</h3>
                            </td>
                            <td>
                              <h3 class="d-inline-flex">{{ obra.total }}</h3>
                            </td>
                            <td style="max-width: 100px;"> 
                              <v-select
                                class="mt-3"
                                dense
                                :items="['MANTER','SUBSTITUIR']"
                                v-model="conflitosAcoes[obra.CodObra]"
                              />
                            </td>
                            <td v-if="key == 0"> 
                              <v-btn
                                color="primary"
                                text
                                @click="replicarAcaoConflito(conflitosAcoes[obra.CodObra])"
                              >
                                <v-icon
                                  small
                                >
                                  mdi-arrow-down-bold
                                </v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <v-card-title class="headline">
            NOVA IMPORTAÇÃO DE DADOS
          </v-card-title>
          <v-card-text>
            <v-divider class="mt-2"></v-divider>
            <v-row>
              <v-col cols="12">
                <div class="caption">
                  PARÂMETROS EXTRAS
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="12">
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr v-if="afetadas.some(e => e.nome === 'georreferenciado')">
                        <td>
                          <date-picker
                            v-model="parametros_extras.DataRegistro"
                            label="Data Registro"
                            type="month"
                            :outlined="true"
                            rules="required|min:7"
                          />
                        </td>
                        <td>
                          <v-text-field
                            v-model="parametros_extras.versao"
                            label="Versão BDGD"
                            type="number"
                          />
                        </td>
                        <td>
                          <v-checkbox
                            v-model="parametros_extras.check_versao_ativa"
                            label="Versão Ativa"
                          />
                        </td>
                      </tr>
                      <tr v-else-if="afetadas.some(e => e.nome === 'ais')">
                        <td>
                          <v-row>
                            <v-col cols="10">
                              <date-picker
                              v-model="parametros_extras.DataRegistro"
                              label="Data Registro"
                              type="month"
                              :outlined="true"
                              rules="required|min:7"
                            />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="10">
                              <v-checkbox
                                v-model="parametros_extras.calculoFluxo"
                                label="Cálculo de Fluxo de Remuneração"
                              />
                            </v-col>
                          </v-row>
                        </td>
                      </tr>
                      <tr v-else-if="afetadas.some(e => e.nome === 'laudo')">
                        <td>
                          <v-row>
                            <v-col cols="10">
                              <date-picker
                                v-model="parametros_extras.DataReferencia"
                                label="Data Referência"
                                type="month"
                                :outlined="true"
                                rules="required|min:7"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="10">
                              <v-checkbox
                                v-model="parametros_extras.calculoFluxo"
                                label="Cálculo de Fluxo de Remuneração"
                              />
                            </v-col>
                          </v-row>
                        </td>
                      </tr>
                      <tr v-else-if="afetadas.some(e => e.nome === 'material')">
                        <td>
                          <v-checkbox
                            v-model="parametros_extras.readivinharTucagemBP"
                            label="Adivinhar Tucagem Banco de Preço"
                          />
                        </td>
                      </tr>
                      <tr v-else>
                        <td>
                          <div class="caption font-weight-light ml-2 mt-n2">
                            Nenhum parâmetro extra se aplica para esta importação
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="12">
                <date-picker
                  v-model="data_agendamento"
                  label="Data Referência"
                  type="month"
                  :outlined="true"
                  rules="required|min:7"
                />
              </v-col>
            </v-row>

            <v-divider></v-divider>
            <v-row>
              <v-col cols="12">
                <div class="caption">
                  AÇÕES
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="12">
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr v-for="(tabela, key) in afetadas">
                        <td>
                          <h3 class="d-inline-flex">{{ tabela.nome.toUpperCase() }}</h3>
                        </td>
                        <td style="max-width: 100px;"> 
                          <v-select
                            class="mt-3"
                            dense
                            :items="['IGNORAR','ATUALIZAR']"
                            v-model="tabela.acao"
                          />
                        </td>
                        <td v-if="key == 0"> 
                          <v-btn
                            color="primary"
                            text
                            @click="replicarAcao(tabela.acao)"
                          >
                            <v-icon
                              small
                            >
                              mdi-arrow-down-bold
                            </v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>   
          </v-card-text>
        </div>
        <v-divider />
        <v-card-actions v-if="conflitos">
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="dialogNovaImportacao=false"
          >
            Fechar
          </v-btn>
          <v-btn
            color="green darken-1"
            @click="salvarConflitos()"
            :disabled="loadingResolucaoConflitos"
            :loading="loadingResolucaoConflitos"
          >
            Salvar
          </v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="dialogNovaImportacao=false"
          >
            Fechar
          </v-btn>
          <v-btn
          color="green darken-1"
          @click="salvarAcoes()"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
  
  <script>
  import ImportacoesDadosService from "@/services/ImportacoesDadosService.js"
  import PreImportacoesDadosService from "@/services/PreImportacoesDadosService.js"

  export default {
    components:{
      DialogMapeamento: () => import('@/components/importacoesDados/administracao/DialogMapeamento.vue'),
      DialogCreationLog: () => import('@/components/general/DialogCreationLog'),
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      DatePicker: () => import("@/components/general/DatePicker.vue"),
    },
  
    props: {
      items: {
        type: Array,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      progresso: {
        type: Object,
        default: () => ({}),
      },
    },

    data: () => ({
      data_agendamento: null,
      parametros_extras: {
        DataRegistro: null,
        versao: null,
        check_versao_ativa: null,
        DataReferencia: null,
        calculoFluxo: null,
        readivinharTucagemBP: null,
      },
      loadingResolucaoConflitos: false,
      conflitos: false,
      conflitosList: [],
      conflitosAcoes: {},
      search: '',
      selectedPreImpo: null,
      dialogMapeamento: false,
      afetadas: [],
      dialogNovaImportacao: false,
      dialogCreationLog: false,
      dialogCreationLogData: {},
      dialogDelete: false,
      dialogDeleteData: {},
      loadingDelete: false,
      loadingLogsPreImportacao: null,
      headers: [
        {
          text: '#',
          value: 'id',
        },
        {
          text: 'Nome do Arquivo',
          value: 'nome',
        },
        {
          text: 'Tipo de Importação',
          value: 'tipo_importacao_dados.tipo',
        },
        {
          text: 'Mapeamento',
          value: 'mapeamento',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Data',
          value: 'data',
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4',
        },
      ],
    }),

    methods:{
      exibeExcluirPreImportacao(item) {
        return item.status !== 'EXECUTANDO' && !item.importacao_dados
      },
      openDialogDelete(item) {
        this.dialogDeleteData = {
          id: item.id,
          nome: item.arquivo_analista_setra ? item.arquivo_analista_setra.arquivo : `#${item.id}`,
        }
        this.dialogDelete = true
      },
      excluirPreImportacao(id) {
        this.loadingDelete = true
        PreImportacoesDadosService.excluir(id)
        .then((resp) => {
          const msg = resp.data && resp.data.msg ? resp.data.msg : 'Pré-importação excluída com sucesso.'
          this.$toast.success(msg, '', { position: 'topRight' })
          this.dialogDelete = false
          this.$emit('recharge')
        })
        .catch((error) => {
          const msg = error && error.data && error.data.erro
            ? error.data.erro
            : `Erro ao excluir pré-importação ${id}.`
          this.$toast.error(msg, '', { position: 'topRight' })
        })
        .finally(() => {
          this.loadingDelete = false
        })
      },
      exibeDownloadLogsPreImportacao(item) {
        const totalLinhasArquivo = Number(item.total_linhas_arquivo || 0)
        const totalLinhasInseridas = Number(item.total_linhas_inseridas || 0)
        const totalLinhasAlertas = Number(item.total_linhas_alertas || 0)
        const totalLinhasErros = Number(item.total_linhas_erros || 0)
        const importacaoParcial = totalLinhasArquivo > 0 && totalLinhasInseridas < totalLinhasArquivo

        return item.status === 'FALHA'
          || importacaoParcial
          || totalLinhasAlertas > 0
          || totalLinhasErros > 0
      },
      downloadLogsPreImportacao(item) {
        this.loadingLogsPreImportacao = item.id
        this.$toast.info('Preparando seu arquivo para download.', '', { position: 'topRight', timeout: 2000 })

        PreImportacoesDadosService.downloadLog(item.id, {
          timeout: 60 * 60 * 1000,
        })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `pre_importacao_${item.id}_logs.zip`)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error(error)
          this.$toast.error(`Erro ao baixar logs da pré-importação ${item.id}.`, '', { position: 'topRight' })
        })
        .finally(() => {
          this.loadingLogsPreImportacao = null
        })
      },
      replicarAcao(acao) {
        this.afetadas.forEach(element => {
          element.acao = acao
        })
      },
      replicarAcaoConflito(acao) {
        this.conflitosList.forEach(element => {
          this.$set(this.conflitosAcoes, element.CodObra, acao)
        })
      },
      salvarConflitos() {
        this.loadingResolucaoConflitos = true
        this.$toast.info(`Resolvendo Conflitos.`, '', {position: 'topRight'})
        PreImportacoesDadosService.processarConflitoImportacao(this.selectedPreImpo.id, {
          tipo: this.selectedPreImpo.tipo_importacao_dados.tipo,
          acoes: this.conflitosAcoes
        })
        .then(() => {
          this.$toast.success(`Conflitos resolvidos.`, '', {position: 'topRight'})
          this.conflitos = false
        })
        .catch(() => { 
          this.$toast.error(`Erro ao resolver conflitos.`, '', {position: 'topRight'})
        })
        .finally(() => this.loadingResolucaoConflitos = false)
      },
      salvarAcoes() {
        const postData = {
          acoes: this.afetadas,
          parametros_extras: this.formatarParametrosExtras(this.parametros_extras)
        };

        ImportacoesDadosService.addImportacao(this.selectedPreImpo.id,postData)
        .then((resp) => {
          this.$toast.success(`Importação criada.`, '', {position: 'topRight'})
          this.$emit('recharge');
          this.$emit('recharge-importacoes');
        })
        .catch(() => { 
          this.$toast.error(`Erro ao salvar importação.`, '', {position: 'topRight'})
        })
        .finally(() => {
          this.dialogNovaImportacao = false;
        });
      },
      getTabelasAfetadas(item) {
        const id = item.id
        this.selectedPreImpo = item;
        this.afetadas = []
        ImportacoesDadosService.getTabelasAfetadas(id)
        .then((resp) => {
          resp.data.tabelas.forEach(tabela => {
            let obj = {
              nome: tabela,
              acao: 'IGNORAR',
            }
            this.afetadas.push(obj)
          })
        })
        .catch((error) => { 
          console.log(error)
          this.$toast.error(`Erro ao buscar tabelas afetadas.`, '', {position: 'topRight'})
        });
      },

      checkConflitos(item) {
        if(item.tipo_importacao_dados.tipo == "RUC_RCO" || item.tipo_importacao_dados.tipo == "AS_BUILT") {
          PreImportacoesDadosService.getConflitos(item.id)
          .then((resp) => {
            this.conflitosList = item.tipo_importacao_dados.tipo == "AS_BUILT" ? resp.data.as_built : resp.data.ruc_rco
            if (!this.conflitosList.length) {
              this.conflitos = false
              this.dialogNovaImportacao = true
              return
            }
            this.conflitosAcoes = {}
            this.conflitosList.forEach(conflito => {
              this.$set(this.conflitosAcoes, conflito.CodObra, 'MANTER')
            })
            this.conflitos = true
            this.dialogNovaImportacao = true
          })
          .catch((error) => { 
            console.log(error)
            this.$toast.error(`Erro ao buscar conflitos.`, '', {position: 'topRight'})
          });
        } else {
          this.dialogNovaImportacao = true
        }       
      },

      formatarParametrosExtras(parametros) {
        const extras = {};
        Object.entries(parametros).forEach(([key, value]) => {
          if (value === null || value === '') return;
          extras[key] = ['DataRegistro', 'DataReferencia'].includes(key)
            ? this.formatarMesReferencia(value)
            : value;
        });
        return extras;
      },

      formatarMesReferencia(value) {
        if (!value || value.includes('/')) return value;
        const [ano, mes, dia] = value.split('-');
        return `${dia || '01'}/${mes}/${ano}`;
      },

      novaImportacao(id) {
        ImportacoesDadosService.novaImportacao(id)
        .then((resp) => {
          this.cabecalhoArquivo = resp.data.cabecalho
          //fill mapeamento
          this.cabecalhoArquivo.forEach(cabecalho => {
            let obj = {
              campo_arquivo: cabecalho,
              campo_hexa: '',
              tipo_dado: '',
              formato_dado: '',
              mascara: '',
              mascara_parametros: '',
              mascara_parametros_valores: ''
            }
            this.mapeamento.push(obj)
          })
          this.linhaArquivo = resp.data.linha
          this.triggerSalvarMapeamento = false
        })
        .catch(() => { 
          this.$toast.error(`Erro ao buscar cabeçalho do arquivo.`, '', {position: 'topRight'})
        });
      },
    }
  }
  </script>
